import { Box } from '@mui/material';
import { styled as muiStyled } from '@mui/material/styles';
import { display } from '@mui/system';
import { ScrollCss } from 'styles/GlobalCss';
import { thirdly4 } from 'styles/theme';
import { white } from 'styles/theme';

const ApplyDataConfirmationStyles = muiStyled(Box)(({ theme, $systemUI }) => ({
    '.confirmation-content': {
        marginBottom: 15,
        fontWeight: "bold"
    }
}));

export const EmptyScreenStyles = muiStyled(Box)(({ theme, $systemUI }) => ({
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    flexDirection: "column",
    rowGap: 22,
    flexGrow: 1,
    '.empty-normalator': {
        background: thirdly4,
        borderRadius: 20,
        padding: "20px 50px"
    },
    '.empty-normalator-img': {
        width: 500,
        height: 200
    },
    '.empty-screen-title': {
        fontSize: 24,
        fontWeight: "bold"
    },
    '.empty-screen-sub-title': {
        textAlign: "center",
        fontSize: 20
    }
}));

const NormalizerStyles = muiStyled(Box)(({ theme, $systemUI }) => ({
    height: "100%",
    overflow: "auto",
    '.header-items': {
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center"
    },
    '.assessment-count': {
        marginBottom: 10
    },
    '.sc-section': {
        width: "100%",
        padding: 10,
        border: `2px solid ${white}`
    },
    '.sc-sections': {
        display: "flex",
        flexDirection: "column",
        rowGap: 15,
        flexGrow: 1,
        overflow: "auto",
        ...ScrollCss,
    },
    '.sc-section-actions': {
        display: "flex",
        columnGap: 5
    },
    '.sc-actions': {
        background: white,
        height: 70,
        width: "100%",
        borderRadius: 5,
        display: "flex",
        alignItems: "center",
        justifyContent: "end",
        padding: 15,
        boxSizing: "border-box"
    },
    '.sc-header-btns': {
        display: "flex",
        columnGap: 5
    }
}));


const GraphStyles = muiStyled(Box)(({ edit, theme, $systemUI }) => ({
    padding: "10px 10px 10px 10px",
    border: `2px solid ${white}`,
    direction: 'ltr',
    background: edit && white,
    display: "flex",
    flexDirection: "column",
    borderRadius: 5,
    rowGap: 10,
    '.sc-table': {
        marginBottom: 20
    },
    '.sc-header-item': {
        alignItems: "center",
        display: "flex",
        justifyContent: "space-between"
    },
    '.sc-detail': {
        display: "flex",
        columnGap: 5
    }
}));

export { ApplyDataConfirmationStyles, NormalizerStyles, GraphStyles }

